$(document).ready(function () {
  $('#trade_names_save').click(function(e){
    e.preventDefault();
    var grid = $('#trade-names-grid').data('kendoGrid');
    var dataSource = grid.dataSource;
    var state = {
        page: dataSource.page(),
        pageSize: dataSource.pageSize(),
        sort: dataSource.sort(),
        filter: dataSource.filter()
    };
    localStorage['kendo-grid-options'] = kendo.stringify(state);
    var test = localStorage['kendo-grid-options']
  });

  $('#trade_names_clear').click(function () {
    window.localStorage.clear();
  });

  $('#trade-names-grid').kendoGrid({
    toolbar: ['excel'],
    excel: {
      filterable: true,
      fileName: 'trade_names_export'
    },
    dataSource: {
      transport: {
        read: {
          url: '/admin/trade_names.json',
          dataType: 'JSON'
        }
      },
      pageSize: 50
    },
    schema: {
      model: {
        id: 'id'
      }
    },
    resizable: false,
    pageable: {
      pageSizes: [10, 25, 50, 100, 'All'],
      input: true,
      numeric: false,
      refresh: true
    },
    sortable: true,
    scrollable: false,
    filterable: {
      mode: 'row'
    },
    columns: [
      {
        field: 'id',
        title: '#',
        width: '12.5%',
        filterable: {
          cell: {
            enabled: true
          }
        }
      },
      {
        field: 'name',
        title: 'Name',
        width: '30%',
        filterable: {
          cell: {
            enabled: true
          }
        },
        template: "<a href='/admin/trade_names/#=id#'>#=name#</a>"
      },
      {
        field: 'trade_type',
        title: 'Trade type',
        width: '12.5%',
        attributes: {
          style: 'text-align: center'
        },
        filterable: false
      },
      {
        field: 'drug_size',
        title: 'Number of Drugs',
        width: '15%',
        attributes: {
          style: 'text-align: center'
        },
        filterable: false
      },
      {
        title: 'Actions',
        width: '30%',
        template: "<a href='/admin/trade_names/#=id#' class='drug_link' target='_blank'>View</a> | <a href='/admin/trade_names/#=id#/edit' target='_blank'>Edit</a> | <a data-confirm='Are you sure?' rel='nofollow' data-method='delete' href='/admin/trade_names/#=id#'>Delete</a>",
      }

    ]
  });

  var grid = $('#trade-names-grid').data('kendoGrid');
  var state = localStorage['kendo-grid-options'];
  if (state) {
      var data = JSON.parse(state);
      var options = grid.options;
      options.dataSource.page = data.page;
      options.dataSource.pageSize = data.pageSize;
      options.dataSource.sort = data.sort;
      options.dataSource.filter = data.filter;
      grid.destroy();
      $('#trade-names-grid')
     .empty()
     .kendoGrid(options);
  }
});
